import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import TableStudentScore from "./TableStudentScore";
import LoadingBtn from "../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../Library/AlertNotif";
import TableStudentScoreLetter from "./TableStudentScoreLetter";
import UpdateComp from "./template-score/UpdateComp";
import { GET_SCR_LECTURER_SECTION } from "./Apis";
import { ProgressScoreGenerate } from "./template-score/ScoreActions";
import { openModal } from "../../../../Library/ModalPopUp";
import { DownloadScore } from "./DownloadScore";
import { UpdataGrade } from "./new-temp-score";

export default function FormScoreComp({
  section_id,
  sectionInfo,
  ReloadSection,
}) {
  try {
    const section_obe = sectionInfo?.section_obe || [];
    if (section_obe && section_obe.length === 0) {
      return (
        <WarningMessage
          title={`Incomplete Course Required`}
          message={
            <span >
              This course is currently <b>ineligible for assessment</b> due to missing Learning outcomes (CPMK) data. <br />
              Please coordinate with the <span className="text-info font-weight-bold mr-1">Head of Study Program {sectionInfo?.cost_center?.name || ''}</span> 
              to fulfill this mandatory requirement.
            </span>
          }

        />
      )
    }

    return <DetailFormComp section_id={section_id} sectionInfo={sectionInfo} ReloadSection={ReloadSection} />;
  } catch (error) {
    return <AlertNotif message={error.message} color="danger" title="Submit Student Score" />;
  }
}

const DetailFormComp = ({
  section_id,
  sectionInfo,
  ReloadSection
}) => {
  const section_com_obe = sectionInfo?.section_com || [];
  const has_map_obe_com = section_com_obe.some(
    (item) => item.section_com_obe && item.section_com_obe.length > 0
  );


  const [updateComponent, setUpdateComponent] = useState(false);
  const [dataScore, setDataScore] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [scrStudent, setScrStudent] = useState([]);
  const [scrCom, setScrCom] = useState([]);

  const [isDownload, setIsDownload] = useState(false);
  const HandlerDownload = () => {
    DownloadScore(section_id, setIsDownload);
  };

  const ResultData = useMemo(() => {
    const studentsWithScores = [...scrStudent];
    studentsWithScores.forEach((student) => {
      scrCom.forEach((scItem) => {
        const alreadyExists = student.student_course_com.some(
          (item) => item.wg_com.id === scItem.wg_com.id,
        );
        if (!alreadyExists) {
          student.comp_status_old = (scItem.wg_com?.type.includes("Formative") || scItem.wg_com?.type.includes("Summative") ? true : false);
          student.student_course_com.push({
            id: Object.values(student.student_course_com).length + 1,
            score: "",
            submitted: "",
            submittedby: "",
            wg_com: scItem.wg_com
          });
        }
      });

      if (student.studentdata && student.studentdata.fullname) {
        student.studentdata.fullname = student.studentdata.fullname
          .split(" ")
          .map(
            (word) =>
              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
          )
          .join(" ");
      }
    });

    studentsWithScores.sort((a, b) => {
      const nameA = a.studentdata?.fullname?.toUpperCase() || "";
      const nameB = b.studentdata?.fullname?.toUpperCase() || "";
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    return studentsWithScores;
  }, [scrStudent, scrCom]);

  const ReloadData = () => {
    GET_SCR_LECTURER_SECTION(
      { section_id: section_id },
      setDataScore,
      setScrStudent,
      setScrCom,
    );
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const message_required = useMemo(() => {
    if (scrCom.length > 0 && sectionInfo) {
      console.log(scrCom);
      return CheckComponents(sectionInfo, scrCom);
    }
    return [];
  }, [scrCom, sectionInfo]);

  const HandlerBack = () => {
    setUpdateComponent(false);
    ReloadData();
    ReloadSection();
  };

  const HandlerLeavePage = () => {
    openModal({
      header: "Confirmation",
      message: (
        <div className="text-center">
          <h4>
            All unsaved information will be lost. Are you sure you want to leave
            this page?
          </h4>
          <div className="btn-group mt-5">
            <button
              className="btn btn-lg btn-light"
              type="button"
              onClick={() => openModal({ open: false })}
            >
              Cancel
            </button>
            <Link
              to={"/class-score-submission"}
              onClick={() => openModal({ open: false })}
              className="btn btn-lg btn-primary"
            >
              Discard Changes
            </Link>
          </div>
        </div>
      ),
    });
  };

  const [progressBar, setProgressBar] = useState(false);
  const HandlerProgressBar = () => {
    setUpdateComponent(false);
    setProgressBar(true);
    ReloadData();
  };

  const HandlerProgressComplete = () => {
    setProgressBar(false);
    ReloadSection();
  };

  if (!has_map_obe_com) {
    return (
      <UpdataGrade
        section_id={section_id}
        HandlerBack={HandlerBack}
        HandlerProgressBar={()=>window.location.reload()}
      />
    );
  }

  if (updateComponent) {
    return (
      <UpdataGrade
        section_id={section_id}
        HandlerBack={HandlerBack}
        HandlerProgressBar={HandlerProgressBar}
      />
    );
  }
  if (progressBar) {
    return (
      <div className="card">
        <div className="card-body">
          <div className="text-center">
            <h3>Data has been successfully saved</h3>
            <p>Please Wait! We are updating your data.</p>
            <ProgressScoreGenerate
              setProgressBar={setProgressBar}
              start={true}
              onComplete={HandlerProgressComplete}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card card-custom card-fit card-border">
      <div className="card-header">
        <div className="card-title">
          <div className="d-flex align-items-center">
            <div className="border-right pr-3">
              <span
                className="cursor-pointer"
                onClick={() => HandlerLeavePage()}
                title="Back to class list"
              >
                <i className="la la-arrow-circle-left icon-3x text-hover-warning"></i>
              </span>
            </div>
            <div className="title d-flex align-items-center ml-5">
              <span className="card-icon">
                <i className="flaticon2-writing"></i>
              </span>
              <h3 className="card-label">Student List</h3>
            </div>
          </div>
        </div>
        <div className="card-toolbar">
          {has_map_obe_com && Object.values(dataScore.data).length > 0 && (
            <>
              {dataScore.data.allowed === 1 &&
                dataScore.data.score_type === 1 && (
                  <div className="btn-group mr-2">
                    <button
                      className="btn btn-icon btn-primary btn-lg"
                      type="button"
                      onClick={() => setUpdateComponent(true)}
                    >
                      <i className="flaticon-cogwheel-2"></i>
                    </button>
                    <button
                      className="btn btn-light-primary btn-lg font-weight-bolder"
                      type="button"
                      onClick={() => setUpdateComponent(true)}
                    >
                      <span>Assessment Instrument Setting</span>
                    </button>
                  </div>
                )}
              <div className="btn-group mr-2">
                <button
                  className="btn btn-icon btn-primary btn-lg"
                  type="button"
                >
                  <i className="flaticon2-download-2"></i>
                </button>
                <button
                  className="btn btn-light-primary btn-lg font-weight-bolder"
                  type="button"
                  disabled={isDownload}
                  onClick={() => HandlerDownload()}
                >
                  <span>
                    {isDownload ? "Processing..." : "Export to excel"}
                  </span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="card-body py-0">
        {dataScore.loading ? (
          <LoadingBtn />
        ) : dataScore.message ? (
          <AlertNotif message={dataScore.message} color={"danger"} />
        ) : (Object.values(dataScore.data).length > 0 && Object.values(scrStudent).length > 0) ? (
          <>
            {dataScore.data.allowed === 0 && (
              <div className="alert alert-custom alert-light-danger fade show mb-5">
                <div className="alert-icon">
                  <i className="flaticon-warning"></i>
                </div>
                <div className="alert-text d-flex flex-column">
                  <h5 className="mb-1">Grading Period Closed</h5>
                  <span>
                    Grade submission period for the{" "}
                    <span className="font-weight-bolder">
                      {sectionInfo?.atp_term?.name}
                    </span>{" "}
                    term has been closed. No further entries or edits can be
                    made.
                    <br /> Please contact the AOO if you have any questions or
                    require assistance.
                  </span>
                </div>
              </div>
            )}
            {dataScore.data.score_type !== 1 ? (
              <TableStudentScoreLetter
                allowed={dataScore.data.allowed}
                data={ResultData}
                section_id={section_id}
                ReloadData={ReloadData}
                HandlerLeavePage={HandlerLeavePage}
              />
            ) : (
              (Object.values(scrCom).length === 0) ? (
                <UpdataGrade
                  section_id={section_id}
                  HandlerBack={HandlerBack}
                  HandlerProgressBar={HandlerProgressBar}
                />
              ) : (
                <TableStudentScore
                  allowed={dataScore.data.allowed}
                  data={ResultData}
                  ReloadData={ReloadData}
                  components={scrCom}
                  scrStudent={scrStudent}
                  setScrStudent={setScrStudent}
                  sectionInfo={sectionInfo}
                  section_id={section_id}
                  HandlerProgressBar={HandlerProgressBar}
                />
              )
            )}
          </>
        ) : (
          <AlertNotif
            title="No Student Enrollment"
            message={"There are currently no students enrolled in this course. Please contact the Academic Office for enrollment updates."}
            color="danger"
          />
        )}
      </div>
    </div>
  );
}

const CheckComponents = (sectionInfo, components, is_current_term) => {
  const totalWeight = components.reduce((total, component) => {
    return total + component.weight;
  }, 0);
  const section_com = sectionInfo?.section_com ? sectionInfo?.section_com : [];
  const has_old_com = section_com.some(
    (com) => com.wg_com.type === "Formative" || com.wg_com.type === "Summative",
  );
  const has_obe = sectionInfo?.section_com?.some(
    (com) => com.section_com_obe && com.section_com_obe.length > 0,
  );

  let message_required = [];
  if (is_current_term) {
    if (has_old_com) {
      message_required.push("❌ Assessment components not yet available.");
    } else {
      if (totalWeight !== 100) {
        message_required.push(
          `❌ Total weight (${totalWeight.toFixed(0)}%) is ${totalWeight < 100 ? "less than" : "over"} 100%, please update the weights of components`,
        );
      }
    }

    if (!has_obe) {
      message_required.push(
        "❌ This course has no CPMK. Please add CPMK first.",
      );
    }
  } else {
    if (totalWeight !== 100) {
      message_required.push(
        `❌ Total weight (${totalWeight.toFixed(0)}%) is ${totalWeight < 100 ? "less than" : "over"} 100%, please update the weights of components`,
      );
    }
  }

  return message_required;
};

export const RenderMessagePrerequisite = ({ messages }) => {
  return (
    <ul className="mb-0 pl-0" style={{ listStyle: "none" }}>
      {messages.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};


const WarningMessage = ({ icon = `flaticon-warning`, title, message }) => {
  return (
    <div className="border rounded p-5 pb-10 text-center shadow bg-white">
      <div className="icon mb-1">
        <i
          className={`text-danger ${icon}`}
          style={{ fontSize: "6em" }}
        ></i>
      </div>
      <h1>{title}</h1>
      <p className="font-size-lg mb-10">{message}</p>
      <Link to={"/class-score-submission"} className="btn btn-lg btn-primary mb-10" type="button">
        Back to Class in session
      </Link>
    </div>
  )
}